import { cn } from '@/lib/utils';

/**
 * A-Roll / B-Roll corner badge. A-roll is the story spine (characters, dialogue);
 * B-roll is supporting/cutaway coverage.
 */
export default function RollBadge({ roll, label, dim }: { roll: string; label: string; dim?: boolean }) {
  const aRoll = roll === 'a_roll';
  return (
    <div
      className={cn(
        'absolute right-1 top-1 rounded px-1.5 py-0.5 text-[9px] font-bold',
        aRoll ? 'text-white' : 'text-black',
        aRoll ? (dim ? 'bg-blue-600/40' : 'bg-blue-600/90') : dim ? 'bg-amber-500/40' : 'bg-amber-500/90',
      )}
    >
      {label}
    </div>
  );
}
